import React from 'react';

const AuthorBadge = ({ author, date, className = "", variant = "dark" }) => {
    if (!author) return null;

    const isLight = variant === "light";

    return (
        <div className={`flex items-center gap-3 ${className}`}>
            <div className={`w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-bold text-xs overflow-hidden border-2 ${isLight ? 'border-white/40 shadow-none' : 'border-white shadow-sm'}`}>
                {author.image_url ? (
                    <img src={author.image_url} alt={author.name} className="w-full h-full object-cover" />
                ) : (
                    author.name?.charAt(0).toUpperCase() || 'A'
                )}
            </div>
            <div className="flex flex-col">
                <span className={`text-sm font-bold leading-none mb-1 ${isLight ? 'text-white' : 'text-gray-900'}`}>
                    {author.name || 'Admin'}
                </span>
                {date && (
                    <span className={`text-[10px] font-medium ${isLight ? 'text-white/70' : 'text-gray-500'}`}>
                        {date}
                    </span>
                )}
            </div>
        </div>
    );
};

export default AuthorBadge;
